export enum PdfButtonStatus {
  ENABLED,
  DISABLED,
  BUSY,
  UNAVAILABLE
}